import React, { useState, useRef, useCallback } from "react";
import { useForm } from "react-hook-form";
import styles from "./Casefile.module.scss";
import Pebble1 from "../Static assets/Rock progress bar/rock1-01.svg";
import Pebble2 from "../Static assets/Rock progress bar/rock2-01.svg";
import Pebble3 from "../Static assets/Rock progress bar/rock3-01.svg";
import Pebble4 from "../Static assets/Rock progress bar/rock4-01.svg";
import Pebble5 from "../Static assets/Rock progress bar/rock5-01.svg";
import Pebble6 from "../Static assets/Rock progress bar/rock6-01.svg";
import Pebble7 from "../Static assets/Rock progress bar/rock7-01.svg";
import Pebble8 from "../Static assets/Rock progress bar/rock8-01.svg";
import Celebration from "../Champions:folk/All done.gif";
import CloseButton from "../Static assets/Crosses/Cross-01.png";

function Questions(props) {
  const { register, handleSubmit, watch, errors } = useForm();
  const selected = props.selected;
  const setShowComment = props.setShowComment;
  const setSelected = props.setSelected;
  const setReport = props.setReport;
  const postMarker = props.postMarker;
  const [query, setShowQuery] = React.useState(0);
  const [statement, setStatement] = React.useState({
    folk: props.type,
    nonhumantype: "",
    url: "",
    allegation: "",
    affected: "",
    video: "",
    link: "",
    image: "",
    problem: "",
    better: "",
    solution: "",
    done: false,
  });

  const onSubmit = (data) => {
    const keys = Object.keys(data);
    setShowQuery(query + 1);
    keys.forEach((element) => {
      statement[element] = data[element];
    });
    console.log(statement);
    console.log(query);
    console.log(statement.folk);
  };

  const currentMarker = props.currentMarker;
  if (selected) {
    return (
      <div className={styles.queryBox}>
        <button
          className={styles.close}
          onClick={(event) => {
            setShowComment(false);
            setSelected(null);
          }}
        >
          <img src={CloseButton} />
        </button>
        <br />
        {selected.points && <p>Points: {selected.points}</p>}
        <p> {selected}</p>
        <ul></ul>(<button>Submit Full Report</button>)
      </div>
    );
  }

  function setUrl(currentStatement) {
    statement.url = currentStatement.incidenttype;
  }

  function handleClick(value) {
    setShowQuery(value);
  }

  return (
    <div className={styles.queryBox}>
      <img
        className={styles.close}
        src={CloseButton}
        onClick={(event) => {
          setShowComment(false);
          setSelected(null);
        }}
      />

      <ul className={styles.pebbles}>
        <li>
          {query === 0 && <img src={Pebble1} className={styles.selected} />}
          {query !== 0 && <img src={Pebble1} className={styles.done} />}
        </li>

        <li>
          {query === 1 && <img src={Pebble2} className={styles.selected} />}
          {query < 1 && <img src={Pebble2} className={styles.notSelected} />}
          {query > 1 && <img src={Pebble2} className={styles.done} />}
        </li>

        <li>
          {query === 2 && <img src={Pebble3} className={styles.selected} />}

          {query < 2 && <img src={Pebble3} className={styles.notSelected} />}
          {query > 2 && <img src={Pebble3} className={styles.done} />}
        </li>

        <li>
          {query === 3 && <img src={Pebble4} className={styles.selected} />}

          {query < 3 && <img src={Pebble4} className={styles.notSelected} />}
          {query > 3 && <img src={Pebble4} className={styles.done} />}
        </li>

        <li>
          {query === 4 && <img src={Pebble5} className={styles.selected} />}
          {query < 4 && <img src={Pebble5} className={styles.notSelected} />}
          {query > 4 && <img src={Pebble5} className={styles.done} />}
        </li>

        <li>
          {query === 5 && <img src={Pebble6} className={styles.selected} />}

          {query < 5 && <img src={Pebble6} className={styles.notSelected} />}
          {query > 5 && <img src={Pebble6} className={styles.done} />}
        </li>

        <div className={styles.encouragement}>
          {query === 0 && <p>Ready to start?</p>}
          {query === 1 && <p>One down...</p>}
          {query === 2 && <p>Nice work!</p>}
          {query === 3 && <p>Half way there!</p>}
          {query === 4 && <p>Nice reporting!</p>}
          {query === 5 && <p>Last one!</p>}
          {query === 6 && <p>Congratulations!</p>}
        </div>
      </ul>
      <br />
      <br />
      <h1 className={styles.markerHeader}>MARKER SUBMISSION</h1>
      <form className={styles.questions} onSubmit={handleSubmit(onSubmit)}>
        {query === 0 && (
          <>
            <p>
              I see you are one of the {props.type} Folk, but what type of being
              are you?
            </p>
            <p>I am a: </p>
            <input
              rows="4"
              className={styles.textInput}
              name="nonhumantype"
              defaultValue=""
              ref={register({ required: true })}
            />
            <br />
            <input type="submit" className={styles.submitButton} />
          </>
        )}
        {query === 1 && (
          <>
            <div className={styles.radio}>
              <p>This kind of incident happened to me: </p>
              <input
                className
                type="radio"
                name="url"
                ref={register({ required: true })}
                value="https://raw.githubusercontent.com/conwayhub/markertests/master/Shapes/circle-01.svg"
              />
              Crime
              <br />
              <input
                type="radio"
                name="url"
                ref={register({ required: true })}
                value="https://raw.githubusercontent.com/conwayhub/markertests/master/Shapes/diamond-01.svg"
              />
              Food
              <br />
              <input
                type="radio"
                name="url"
                ref={register({ required: true })}
                value="https://raw.githubusercontent.com/conwayhub/markertests/master/Shapes/star-01.svg"
              />
              Space
              <br />
              <input
                type="radio"
                name="url"
                ref={register({ required: true })}
                value="https://raw.githubusercontent.com/conwayhub/markertests/master/Shapes/triangle-01.svg"
              />
              Health
              <br />
              <input
                type="radio"
                name="url"
                ref={register({ required: true })}
                value="https://raw.githubusercontent.com/conwayhub/markertests/master/Shapes/hexagon-01.svg"
              />
              Pollution
              <br />
              <input
                type="radio"
                name="url"
                ref={register({ required: true })}
                value="https://raw.githubusercontent.com/conwayhub/markertests/master/Shapes/square-01.svg"
              />
              Behavior
              <br />
              <br />
            </div>
            <input type="submit" className={styles.submitButton} />
          </>
        )}
        {query === 2 && (
          <>
            <p>
              <h2> What happened?</h2>
              <p>
                <i>Describing the scene. (20 points)</i>
              </p>

              <p>
                The Town Hall judges might not be able to visit the site of the
                incident themselves. So tell us enough details and facts such
                that the Judges can get a clear picture of the problem or
                incident. If relevant, you can include descriptions like the
                time of day, weather conditions, nearby objects/people, as well
                as the incident itself.{" "}
              </p>
              <ul>
                <li>
                  <p>
                    {" "}
                    Give a vivid and clear description of the incident or
                    problem. <i>(10 points)</i>
                  </p>
                </li>
                <li>
                  <p>
                    Provide links to good supporting documents, such as photos,
                    video and audio recordings of the incident, or to
                    news/academic articles about that problem.{" "}
                    <i>(10 points)</i>
                  </p>
                </li>
              </ul>
            </p>
            <textarea
              className={styles.textArea}
              rows="6"
              name="allegation"
              defaultValue=""
              ref={register({ required: true })}
            />
            <br />
            <input
              className={styles.textInput}
              name="link"
              defaultValue="video, image, or article URL"
              ref={register}
            />
            <br />
            <input
              className={styles.textInput}
              name="link2"
              defaultValue="video, image, or article URL"
              ref={register}
            />
            <br />
            <input
              className={styles.textInput}
              name="link3"
              defaultValue="video, image, or article URL"
              ref={register}
            />
            <br />
            <input type="submit" className={styles.submitButton} />
          </>
        )}
        {query === 3 && (
          <>
            <h2>Why is this an issue? </h2>
            <p>
              <i>Explaining impact and consequences. (20 points)</i>
            </p>

            <p>
              Humans don’t always understand the impact of things on nonhumans
              and you need to spell it out sometimes. So far, you have described
              the incident, but tell the judges here about (1) the impact on
              you, and (2) wider impact.
            </p>

            <ul>
              <li>
                <p>
                  Tell your story of how the incident impacts you or your
                  family/friends as a nonhuman person to help the human Judges
                  empathise with your circumstances. (10 points)
                </p>
              </li>
              <li>
                <p>
                  Explain how your incident has a wider ecological or
                  environmental impact and consequences that affects all of us
                  humans and nonhumans. (10 points)
                </p>
              </li>
            </ul>

            <textarea
              className={styles.textArea}
              rows="6"
              name="feelings"
              defaultValue=""
              ref={register({ required: true })}
            />
            <br />
            <input type="submit" className={styles.submitButton} />
          </>
        )}
        {query === 4 && (
          <>
            <h2> What should we do about it? </h2>
            <p>
              <i> Proposing a solution. (10 points)</i>
            </p>

            <p>
              The Judges will be humans who have the power to make real
              decisions about your problem. They don’t require you to come up
              with a perfect solution. They will be debating and working out the
              practicalities themselves. But it would help them to hear what
              ideas you might have from a nonhuman point of view for solving the
              problem you have identified.{" "}
            </p>

            <ul>
              <li>
                <p>
                  Suggest one or more practical solutions that you think the
                  Judges should consider.<i> (10 points)</i>
                </p>
              </li>
            </ul>

            <textarea
              className={styles.textArea}
              rows="6"
              name="solution"
              defaultValue=""
              ref={register({ required: true })}
            />
            <br />
            <input type="submit" className={styles.submitButton} />
          </>
        )}
        {query === 5 && (
          <div className={styles.last}>
            <p>
              Great work! Now you're ready to submit your marker, and see it
              show up on the map!
            </p>
            <button
              className={styles.finalSubmit}
              onClick={(e) => {
                setShowQuery(query + 1);
                setTimeout((e) => {
                  postMarker(statement);
                }, 3000);
                // postMarker(statement);
              }}
            >
              COMPLETE SUBMISSION
            </button>
          </div>
        )}{" "}
        {query === 6 && (
          <>
            <img src={Celebration} />
            <br />
            <b>
              <u>ALL DONE!</u>
            </b>
            <p>
              You have successfully placed an incident marker which will appear
              in the map now.
            </p>
            <p>
              Check back later to reach your incident report text once it has
              been moderated. Tap anywhere to return to the game to leave more
              incident markers.
            </p>
          </>
        )}
      </form>
    </div>
  );
}

export default Questions;
